<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="24">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('commonInfo.ChangePassword')"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form class="edit-form" :model="password" label-width="80px">
          <el-form-item :label="$t('commonInfo.OldPassword')">
            <el-input
              v-model="password.old_password"
              show-password
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('commonInfo.NewPassword')" prop="name">
            <el-input
              v-model="password.new_password"
              show-password
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="width: 100px"
              @click="saveNewPassword"
              >{{ $t("commonInfo.Save") }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "UpdateThePasswordView",
  data() {
    return {
      loading: false,
      password: {
        old_password: "",
        new_password: "",
      },
    };
  },
  methods: {
    saveNewPassword() {
      if (this.password.old_password.length === 0) {
        this.$message.error(this.$t("commonInfo.OldPasswordEmptyWarning"));
        return;
      }

      if (this.password.new_password.length === 0) {
        this.$message.error(this.$t("commonInfo.NewPasswordEmptyWarning"));
        return;
      }

      if (this.password.old_password === this.password.new_password) {
        this.$message.error(this.$t("commonInfo.OldNewSameWarning"));
        return;
      }

      let _me = this;
      let params = {
        old_password: this.$md5(this.password.old_password),
        new_password: this.$md5(this.password.new_password),
      };
      this.$common
        .httpPost("/api/user/update/password", params)
        .then((res) => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success(this.$t("commonInfo.PasswordModifySuccess"));
            _me.goBack();
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message.error(err);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}

.edit-form {
  margin: 20px 10px 10px 0;
  text-align: left;
  min-width: 600px;
  max-width: 600px;
}
</style>